<template>
  <div class="home-empty">
    <img
      src="@/assets/dashboard/no-data-cloud.png"
      alt=""
      class="home-empty__img"
      :style="{ width: size + 'px' }"
    >
    <span>{{ $t('there is no enough information for showing.') }}</span>
  </div>
</template>

<script>
export default {
  name: 'HomeEmptyState',
  props: {
    size: {
      type: [Number, String],
      default: 100
    }
  }
}
</script>

<style scoped>
.home-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 12px;
  color: #6B7280;
  text-align: center;
  width: 100%;
}
.home-empty__img {
  height: auto;
  display: block;
  max-width: 100%;
}
</style>
